import React from "react";
import { NumberInput } from "react-admin";
import { InputAdornment } from "@material-ui/core";

const CurrencyInput = props => {
    const { label, source, ...rest } = props;

    return (
        <NumberInput
            label={label}
            min={0}
            step={0.01}
            source={source}
            {...rest}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        {"€"}
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default CurrencyInput;
